"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToGatsbyGraphQLId = void 0;
/**
 * Converts an id to the type of id created by gatsby-node-helpers used on Gatsby nodes.
 *
 * @param {string} prefix
 * @param {string} type
 * @param {(string | number)} id
 * @returns {(void | string)}
 */

function convertToGatsbyGraphQLId(id, type, prefix) {
  return !id ? null : !type ? id : "".concat(prefix, "__").concat(type, "__").concat(id);
}

exports.convertToGatsbyGraphQLId = convertToGatsbyGraphQLId;